module.exports = __webpack_public_path__ + "static/icon-duck-c7de440eb85e5b941800881de4a8889f.png";